import React, { useEffect, useState } from 'react';
import { getCurrentUser } from './aws-auth';
import { Modal, Box, Typography, Button } from '@mui/material';
import { useNavigate } from 'react-router-dom';

interface UserDetails {
    [key: string]: string;
}

const HelloUser: React.FC = () => {
    const [user, setUser] = useState<UserDetails | null>(null);
    const [openModal, setOpenModal] = useState(false);
    const navigate = useNavigate();

    useEffect(() => {
        getCurrentUser()
            .then((userDetails: UserDetails) => {
                setUser(userDetails);
            })
            .catch((error: any) => {});
    }, []);

    useEffect(() => {
        const intervalId = setInterval(() => {
            getCurrentUser()
                .then((userDetails: UserDetails) => {
                    setUser(userDetails);
                })
                .catch((error: any) => {
                    if (user) {
                        setUser(null);
                        setOpenModal(true); // Open the modal when user is logged out
                    }
                    console.error('Error fetching user details:', error);
                });
        }, 5000);

        return () => clearInterval(intervalId);
    }, [user]);

    const handleCloseModal = () => {
        setOpenModal(false);
        navigate('/login');
    };

    const modalStyle = {
        position: 'absolute' as 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: 400,
        bgcolor: 'background.paper',
        border: '2px solid #000',
        boxShadow: 24,
        p: 4,
    };

    return (
        <>
            {user ? (
                <div>Hello, {user.given_name || (user.email.split('@')[0])}!</div>
            ) : (
                <div>Hello, guest!</div>
            )}

            <Modal
                open={openModal}
                onClose={handleCloseModal}
                aria-labelledby="logout-modal-title"
                aria-describedby="logout-modal-description"
            >
                <Box sx={modalStyle}>
                    <Typography id="logout-modal-title" variant="h6" component="h2">
                        You've been logged out
                    </Typography>
                    <Typography id="logout-modal-description" sx={{ mt: 2 }}>
                        Your session has been terminated due to suspicious activity.
                    </Typography>
                    <Button onClick={handleCloseModal} sx={{ mt: 2 }}>
                        Close
                    </Button>
                </Box>
            </Modal>
        </>
    );
};

export default HelloUser;